export default __webpack_public_path__ + "static/media/Dead (4).40243a66.png";